<script>
  import { Link, navigate } from "../router";
  import { getUser } from "../user.js";
  import { onMount } from "svelte";

  import { HStack, VStack, Spacer } from "../component/layout";
  import { Label, Image, Icon } from "../component/widget";
  import {
    Background,
    Font,
    ForegroundColor,
    Padding,
    Center,
    Frame,
    Border,
  } from "../component/modifier";

  import CookieConsent from "../component/CookieConsent.svelte";
  import Header from "../component/Header.svelte";
  import Copyright from "../component/Copyright.svelte";
  import WeddingCell from "../component/WeddingCell.svelte";
  import CreateOrJoin from "../component/JoinOrCreate.svelte";
  import Join from "../component/Join.svelte";
  import Create from "../component/Create.svelte";

  import { getWeddings } from "../wedding.js";

  export let wedding_guid;

  let showCreateOrJoin = false;
  let isCreate = false;
  let isJoin = false;

  function showCreateOrJoinWedding() {
    showCreateOrJoin = true;
  }

  let weddings = getWeddings();
  let organizing = weddings.organizing;
  let attending = weddings.attending;

  let userRequest;

  onMount(() => {
    console.log("Select on mount");

    userRequest = getUser();

    const unsubscribe = userRequest.subscribe((promise) => {
      promise
        .then(() => {
          if (wedding_guid != "") {
            organizing.subscribe((o) => {
              if (o.some((w) => w.guid == wedding_guid)) {
                navigate(`#/dashboard/${wedding_guid}`);
              }
            });

            attending.subscribe((a) => {
              if (a.some((w) => w.guid == wedding_guid)) {
                navigate(`#/wedding/${wedding_guid}/A`);
              }
            });
          }
        })
        .catch((e) => {
          navigate("/");
        });
    });

    return () => {
      console.log("Select destroy");
      unsubscribe();
    };
  });
</script>

<main>
  <CookieConsent />
  <Header />

  {#if showCreateOrJoin}
    <CreateOrJoin on:close={() => (showCreateOrJoin = false)} bind:isCreate bind:isJoin />
  {/if}

  {#if isJoin}
    <Join on:close={() => (isJoin = false)} />
  {/if}

  {#if isCreate}
    <Create on:close={() => (isCreate = false)} />
  {/if}

  <div>
    <Background color="var(--primary-light-gray-color)">
      <Padding>
        <HStack>
          <Spacer />
          <Font name="Cinzel" size="1.25em">Sélectionner un mariage</Font>
          <Spacer />
        </HStack>
      </Padding>
    </Background>
    <Background color="var(--primary-x-dark-gray-color)">
      <Padding top="2em">
        <HStack justify="space-around" wrap>
          {#each $organizing as w}
            <WeddingCell name={w.name} action={() => navigate(`#/dashboard/${w.guid}`)} />
          {/each}

          {#each $attending as w}
            <WeddingCell
              name={w.name}
              thumbnail="ic_coeurVertx3"
              action={() => navigate(`#/wedding/${w.guid}/A`)} />
          {/each}

          <WeddingCell name="Créer ou rejoindre un mariage" action={showCreateOrJoinWedding}>
            <div slot="thumbnail">
              <Icon name="plus" size="135" color="#4a4c45" />
            </div>
          </WeddingCell>
        </HStack>
      </Padding>
    </Background>
  </div>

  <Copyright company="KiwisApp" />
</main>
